// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".courses[data-v-cc2868b8],\n.tracks[data-v-cc2868b8] {\n  max-height: 200px;\n  margin: 10px 0;\n  overflow: auto;\n}\n", ""]);
// Exports
module.exports = exports;
